import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function Humanitarian() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation();
  const [screenX, setScreenX] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleSize = () => {
      setScreenX(window.innerWidth);
    };
    window.addEventListener("resize", handleSize);
    return () => {
      window.removeEventListener("resize", handleSize);
    };
  }, []);

  return (
    <>
      {selectedElement ? (
        <section className='bg-background-secondary min-h-screen flex items-center justify-center'>
          {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
        </section>
      ) : (
        <section className="w-full min-h-screen p-2 pt-20 md:pt-24 bg-background-secondary overflow-x-hidden transition-colors duration-300">
          <div className="flex flex-col items-center px-4">
            
            {/* Back Button */}
            <div className="w-full max-w-6xl mb-4">
              <Link to="/TPQVS">
                <button className="btn-primary inline-flex items-center px-5 py-2.5 text-sm md:text-base transition-transform transform hover:scale-105">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            {/* Layout das Colunas e Texto */}
            <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-12 md:gap-16 lg:gap-24 w-full max-w-6xl">
              
              {/* Container da Tabela  */}
              {/* O transform scale faz a tabela crescer visualmente (ex: 25% a 35% maior no desktop) */}
              <div className="w-fit flex justify-center md:pt-4">
                <div className="grid grid-cols-2 text-center gap-0 transform scale-110 md:scale-125 lg:scale-145 origin-top">
                  {renderColumn(elements, 0, 7, true, 0, handleElementClick, setSelectedElement, false, false, false, true, false, null)}
                  {renderColumn(elements, 7, 13, true, 1, handleElementClick, setSelectedElement, false, false, false, true, false, null)}
                </div>
              </div>

              {/* Card de Texto  */}
              <div className={`${screenX <= 768 ? 'w-full' : "w-2/4"} mt-5 mb-5 p-6 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary z-10 transition-colors duration-300`}>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 text-text-primary border-b-2 border-primary pb-2">
                  {t("Humanitarian.Humanitarian")} {t("Humanitarian.Elements")}
                </h2>
                <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                  {t("Humanitarian.discretion")}
                </p>
              </div>

            </div>
          </div> 
        </section>
      )}
    </>
  );
}